import { render, staticRenderFns } from "./NavigationsButtons.vue?vue&type=template&id=08413e29&"
import script from "./NavigationsButtons.vue?vue&type=script&lang=js&"
export * from "./NavigationsButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports